import React, { PropsWithChildren } from 'react';

export const SideBarContent = (props: PropsWithChildren<any>) => {
  return (
    <div className="app-page-content-sidebar">
      {props.children}
    </div>
  );
};